// PastPapersCard.jsx
import React, { useState } from "react";
import { Box, Flex, Text, IconButton, HStack, VStack, Button, Collapse, Image } from "@chakra-ui/react";
import ButtonUpChevron from "../Images/Button-Up-Chevron-icon-Stande2.0.svg";
import ButtonDownChevron from "../Images/Bottom-Chevron-Icon-Stande2.0.svg";
import ArrowRight from "../Images/Arrow-Right-icon-Stande2.0.svg";
import MinusIcon from "../Images/Minimis/Minus-Icon-Stande2.0.svg";
import DownloadIcon from "../Images/Download-Icon-Stande2.0.svg";
import SolveIcon from "../Images/Solve-Icon-Stande2.0.svg";
import { a } from "./appColors";

const Row = ({ item, onSolve, onDownloadQP, onDownloadMS }) => {
  const [open, setOpen] = useState(false);
  return (
    <Box>
      <Flex
        w="100%"
        h="39px"
        px="6px"
        py="7px"
        align="center"
        justify="space-between"
        borderBottom="1px solid" borderBottomColor={a.border}
        bg={a.surface}
        borderRadius="6px"
        _hover={{ bg: a.hover }}
        onClick={() => setOpen((s) => !s)} 
        cursor="pointer"
      > 
        <Text
          flex="1"
          mr="8px"
          color={a.text2}
          fontSize="14px"
          fontWeight="400"
          lineHeight="normal"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {item.label}
        </Text>
        <IconButton
          aria-label={open ? "Collapse" : "Expand"}
          minW="28px"
          h="28px"
          bg="transparent"
          borderRadius="full"
          _hover={{ bg:"#ffffff"}}
          icon={<Box as="img" src={open ? MinusIcon : ArrowRight} alt="" w="20px" h="20px" />}
        />
      </Flex>
      <Collapse in={open} animateOpacity>
        <HStack spacing="14px" pl="6px" pt="8px" pb="10px">
          <Button
            onClick={() => onSolve?.(item)}
            variant="ghost"
            px="8px"
            py="4px"
            borderRadius="24px"
            border="0.5px solid" borderColor={a.border}
            bg={a.materialBg}
            _hover={{ opacity: 0.85 }}
            leftIcon={<Box as="img" className="material-icon" src={SolveIcon} alt="" w="16px" h="16px" />}
          >
            <Text color={a.materialText} fontSize="12px" fontWeight="400" lineHeight="normal">Solve Online</Text>
          </Button>
          <Button
            onClick={() => onDownloadQP?.(item)}
            variant="ghost"
            px="8px"
            py="4px"
            borderRadius="24px"
            border="0.5px solid" borderColor={a.border}
            bg={a.materialBg}
            _hover={{ opacity: 0.85 }}
            leftIcon={<Box as="img" className="material-icon" src={DownloadIcon} alt="" w="16px" h="16px" />}
          >
            <Text color={a.materialText} fontSize="12px" fontWeight="400" lineHeight="normal">Download Question Paper</Text>
          </Button>
          <Button
            onClick={() => onDownloadMS?.(item)}
            variant="ghost"
            px="8px"
            py="4px"
            borderRadius="24px"
            border="0.5px solid" borderColor={a.border}
            bg={a.materialBg}
            _hover={{ opacity: 0.85 }}
            leftIcon={<Box as="img" className="material-icon" src={DownloadIcon} alt="" w="16px" h="16px" />}
          >
            <Text color={a.materialText} fontSize="12px" fontWeight="400" lineHeight="normal">Download Mark Scheme</Text>
          </Button>
        </HStack>
      </Collapse>
    </Box>
  );
};

const PastPapersCard = ({ title, items = [], onSolveRow, onDownloadQPRow, onDownloadMSRow }) => {
  const [open, setOpen] = useState(false);
  return (
    <Box w={{ base: "100%", md: "661px" }} border="1px solid" borderColor={a.border} borderRadius="14px" bg={a.surface} cursor="pointer">
      <Flex h="70px" px="24px" align="center" justify="space-between"           onClick={() => setOpen((s) => !s)}>
        <Text color={a.text2} fontFamily='"Mona Sans", sans-serif' fontSize="16px" fontWeight="500" lineHeight="normal">
          {title}
        </Text>
        <Image
              src={open ? ButtonUpChevron : ButtonDownChevron}
              alt=""
              w="20px"
              h="20px"
            /> 
      </Flex>
      <Collapse in={open} animateOpacity>
        <VStack align="stretch" spacing="8px" px="16px" pb="16px">
          {items.map((it) => (
            <Row
              key={it.id}
              item={it}
              onSolve={onSolveRow}
              onDownloadQP={onDownloadQPRow}
              onDownloadMS={onDownloadMSRow}
            />
          ))}
        </VStack>
      </Collapse>
    </Box>
  );
};

export default PastPapersCard;
